import React from 'react';
import {PropTypes} from 'prop-types';

const linkStyle = {
  color: "white",
  textDecoration: "none"
};

const SinglePager = ({children, currentPage, itemCount, onChange}) => {

  const renderBack = () => {
    return currentPage > 1
      ? <a data-automation-id="single-pager-back"
           tabIndex="=1"
           onClick={() => onChange(currentPage - 1)}
           style={linkStyle}>
        <i className="icon-back size-large" style={{float: 'left'}}/>
      </a>
      : null;
  };

  const renderForward = () => {
    return currentPage < itemCount
      ? <a data-automation-id="single-pager-forward"
           tabIndex="-1"
           onClick={() => onChange(currentPage + 1)}
           style={linkStyle}>
        <i className="icon-forward size-large"/>
      </a>
      : null;
  };

  return (
    <div className="col-xs-12 padding-vertical type-centeralign" style={{backgroundColor: "#5E4982"}}>
      <div className="col-xs-1 type-leftalign padding-left-none single-pager-container">
        {renderBack()}
      </div>
      <div className="col-xs-10">
        {children}
      </div>
      <div className="col-xs-1 type-rightalign padding-right-none single-pager-container">
        {renderForward()}
      </div>
    </div>
  );

};

SinglePager.propTypes = {
  children: PropTypes.node,
  currentPage: PropTypes.number.isRequired,
  itemCount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default SinglePager;